<ng-template #templateImportBudgetComponent ngxUiLoaderBlurred [loaderId]="'loader-repairers-comission'">
    <div class="modal-upload-file">
        <div class="modal-header">
            <div class="d-flex flex-column">
                <h4 class="modal-title">{{ 'buyer.create-quotation.quotation-import-file.header.title' | translate }}</h4>
                <span class="modal-subtitle">
                    <span>{{ 'buyer.create-quotation.quotation-import-file.header.subtitle' | translate }}</span>
                </span>
            </div>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
        </div>
        <div class="modal-body">
            <div class="content"
                (click)="openFileSelection()"
                (drop)="onDrop($event)"
                (dragover)="onDragOver($event)"
                (dragleave)="stopDrag($event)"
                (dragend)="stopDrag($event)"
            >
                <div class="upload-button">
                    <i-feather name="upload"></i-feather>
                    <div class="text">
                        <p>{{ 'buyer.create-quotation.quotation-import-file.button.import.title' | translate }}</p>
                        <span>{{ 'buyer.create-quotation.quotation-import-file.button.import.subtitle' | translate }}</span>
                    </div>
                </div>
                <input id="input" type="file" accept="application/xml" #fileInput (change)="uploadFile($event)">
            </div>
        </div>
    </div>
</ng-template>
